import { http, baseUrl } from './http.js'

export const get = (url, data) => {
  return http({
    url: url,
    method: "get",
    params: data,
    isMessage: true
  })
}

export const post = (url, data, isMessage = true) => {
  return http({
    url: url,
    method: "post",
    data,
    isMessage: isMessage
  })
}

export { baseUrl };